/* eslint-disable no-throw-literal */
import {
  SHOP_ALL_GET,
  SHOP_ALL_GET_SUCCESS,
  SHOP_ALL_GET_FAILURE,
  GET_SHOP_TARGET_STOCK,
  SORT_MACHINE_ORDER_SHOP
} from './mutation-types'

export default {
  state: {
    shopsAll: []
  },
  getters: {
    shopsAll: state => {
      return state.shopsAll
    }
  },
  actions: {
    [SHOP_ALL_GET] ({dispatch, state, commit}, params = null) {
      var data = params.data || {}
      dispatch('apiGet', {url: '/master/shops/all_get', data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(SHOP_ALL_GET_FAILURE, res.data)
          } else {
            commit(SHOP_ALL_GET_SUCCESS, {data: res.data, callback: params.callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    async [GET_SHOP_TARGET_STOCK] ({ dispatch }, params = {}) {
      const res = await dispatch('apiGet', { url: '/master/shops/get_shop_target_stock', data: params })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [SORT_MACHINE_ORDER_SHOP] ({ dispatch }, params = {}) {
      const res = await dispatch('apiPost', { url: '/master/shops/sort', data: params })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res
    }
  },
  mutations: {
    [SHOP_ALL_GET_FAILURE] (state, data) {
      console.log('SHOP_ALL_GET_FAILURE')
    },
    [SHOP_ALL_GET_SUCCESS] (state, data) {
      console.log('SHOP_ALL_GET_SUCCESS')
      state.shopsAll = data.data.data
      if (data.callback) {
        data.callback()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/shop.js